/* src/app/app.component.css */
html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
}
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.home-content,
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
app-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
app-carrusel {
  margin-top: 56px;
  margin-bottom: 60px;
}
.home-content {
  margin-top: 176px;
}
.main-content {
  margin-top: 176px;
  flex: 1;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/app.component.css.map */
